import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'blz',
  standalone: true,
})
export class BLZPipe implements PipeTransform {
  transform(blz: string | number) {
    if (!blz) return '';
    blz = blz.toString();
    if (!blz) return null;
    return blz.slice(0, 3) + ' ' + blz.slice(3, 6) + ' ' + blz.slice(6, 8);
  }
}
